<template>
<!--  <div v-if="hasSubOrder" class="empty-shopping-cart">-->
<!--    <img class="empty-shopping-cart-ico" src="../../assets/empty_shopping_cart_ico.png" alt="">-->
<!--    &lt;!&ndash; <div class="text01">您尚未预订活动预定产品</div>-->
<!--    <div class="text02">皇家加勒比游轮公司为您准备了多种活动预定产品</div>-->
<!--    <van-button block class="btn-linear-gradient" @click="goNext">快速预订行前订活动产品</van-button> &ndash;&gt;-->
<!--    <div class="text01">您的购物车空空如也</div>-->
<!--    <div class="text02">皇家行前订为您准备了丰富的船上娱乐餐饮活动</div>-->
<!--    <van-button block class="btn-linear-gradient" @click="goNext">马上去看看</van-button>-->
<!--  </div>-->
  <div class="shopping-cart-empty-box">
    <div class="shopping-cart-empty-box__item" v-for="(row,index) in list" :key="index" @click="goLink(row)">
      <h3>{{row.title}}</h3>
      <img :src="row.img" alt=""/>
    </div>
  </div>
</template>

<script>
const imgUrl = process.env.VUE_APP_IMG_URL+'/rcclPcp/mb/';
export default {
  props: {
    hasSubOrder: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      list: [{
        title: '超凡网络',
        img: imgUrl + 'cartBannerWifi.jpg',
        link: 'Wifi'
      },{
        title: '超凡娱乐',
        img: imgUrl + 'cartBannerEntertainment.jpg',
        link: 'entertainment'
      },{
        title: '超凡餐饮',
        img: imgUrl + 'shopping_cart_dinning-mb.jpg',
        link: 'dining'
      },{
        title: '超凡服务',
        img: imgUrl + 'cartBannerService.jpg',
        link: 'service'
      },{
        title: '超凡观光',
        img: imgUrl + 'cartBannerShorex.jpg',
        link: 'pcpShorex'
      }]
    }
  },
  methods: {
    goNext () {
      if (this.$store.getters.isLogin) {
        this.$router.push('/')
      } else {
        this.$router.push('/login')
      }
    },
    goLink({link}) {
      this.$router.push('/Rccl.PCP/product/'+link)
    }
  }
}
</script>

<style lang="less" scoped>
.shopping-cart-empty-box {
  width: 650px;
  & .shopping-cart-empty-box__item {
    background-color: #ffffff;
    border-radius: 10px;
    overflow: hidden;
    & + .shopping-cart-empty-box__item {
      margin-top: 20px;
    }
    & > h3 {
      font-size: 28px;
      padding: 20px 30px;
    }
    & > img {
      display: block;
      width: 100%;
    }
  }
}
.empty-shopping-cart{
  padding-top: 145px;
  font-size: 24px;
  text-align: center;
  color: @main-gray3;
  .text01{
    font-size: 30px;
    color: @main-gray1;
    margin-bottom: 10px
  }
  .text02{
    margin-bottom: 40px;
  }
  /deep/ .van-button--block{
    width: 60%;
    margin: 0 auto;
    color: @main-gray2;
  }
}
.empty-shopping-cart-ico{
  width: 176px;
  height: 150px;
  display: block;
  margin: 0 auto 30px;
}
</style>
